import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import type { CreateSiteData, Site, SiteApiResponse } from '@/types/site';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '../query-key';

export const useCreateSite = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [QUERY_KEYS.sites.createSite],
    mutationFn: async (siteData: CreateSiteData): Promise<Site> => {
      const response = await XHRAuthorizedClient.post<SiteApiResponse>(
        ENDPOINTS.sites.create,
        siteData
      );
      return response.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries();
    },
    onError: (error) => {
      console.error('사이트 생성 오류:', error);
    },
  });
};
